import { find } from 'lodash'
import { createSelector } from 'reselect'

import { areSameValue } from '../../../core/utils'

const selectMenuCurationTaskById = createSelector(
  [
    store => store.menuCurationTasks.menuCurationTasks?.data?.result,
    (state, menuCurationTaskId) => menuCurationTaskId,
  ],
  (menuCurationTasks, menuCurationTaskId) =>
    find(menuCurationTasks, ({ id }) => areSameValue(id, menuCurationTaskId)),
)

export default selectMenuCurationTaskById
